// extracted by mini-css-extract-plugin
export var closeButton = "_c-0";